import React, { Component } from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import {
  Alert,
  Card,
  Accordion,
  Table,
  ProgressBar,
  Badge,
  Button,
  Form,
  InputGroup
} from 'react-bootstrap';
import { findKey, get, isEmpty, isNil, isString, map } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Bert } from 'meteor/themeteorchef:bert';
import uuid from 'uuid/v1';

// import * as connectorOps from '../../../api/Connectors/connector-operations';
import * as nodeOps from '../../../api/Tasks/task-node-operations';
import * as taskOps from '../../../api/Tasks/task-operations';
import { STATUS_TYPES } from '../../../api/Tasks/taskConstants';

import { timeago, monthDayYearAtTime, difference } from '../../../modules/dates';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import Task from '../../../modules/TaskClass';

import ConfirmationModal from '../../atoms/ConfirmationModal';
import PageHeader from '../../atoms/PageHeader';
import TableButtonCell from '../../atoms/TableButtonCell';
import Loading from '../../components/Loading';
import SearchInput from '../../components/SearchInput';
import TablePagination from '../../components/TablePagination';
import Trash from '../../components/Trash';

import Styles from './styles';

const { isBeta } = Meteor.settings.public;

const CLASS_NAME_HEAD_AUTO = 'align-middle w-auto';
const CLASS_NAME_HEAD_25 = 'align-middle w-25';
const CLASS_NAME_DATE_AUTO = 'd-none d-sm-table-cell align-middle w-auto';
const CLASS_BUTTON_CELL = 'd-none py-0 d-sm-table-cell align-middle text-center';
const CLASS_NAME_DATE_AUTO_NP = 'd-none py-0 d-sm-table-cell align-middle w-auto';
const CLASS_NAME_DATE_50_NP = 'd-none py-0 d-sm-table-cell align-middle w-50';
const CLASS_NAME_DATE_33_NP = 'd-none py-0 d-sm-table-cell align-middle w-33';
const CLASS_NAME_DATE_17_NP = 'd-none py-0 d-sm-table-cell align-middle w-17';
const CLASS_NAME_DATE_AUTO_NP_SHOW_XS = 'py-0 d-table-cell align-middle w-auto';
const CLASS_NAME_DATE_50_NP_SHOW_XS = 'py-0 d-table-cell align-middle w-50';

const StatusBadgeIcon = ({ status }) => {
  const statusKey = findKey(STATUS_TYPES, type => type === status);
  const { humanValue, icon, bootstrapVariant } = STATUS_TYPES.properties[statusKey];

  return (
    <Badge variant={bootstrapVariant}>
      {!isNil(icon) && <FontAwesomeIcon icon={icon} spin={status === STATUS_TYPES.INPROGRESS} />}
      {`  ${humanValue}`}
    </Badge>
  );
};

StatusBadgeIcon.propTypes = {
  status: PropTypes.string.isRequired
};

const StatusProgressBar = ({ badge, progress, status }) => {
  const statusKey = findKey(STATUS_TYPES, type => type === status);
  const { bootstrapVariant } = STATUS_TYPES.properties[statusKey];

  const label = badge ? <StatusBadgeIcon status={status} /> : `${progress}%`;

  return (
    <ProgressBar
      className="w-100 d-none d-sm-block"
      label={label}
      now={Number(progress)}
      variant={bootstrapVariant}
    />
  );
};

StatusProgressBar.defaultProps = {
  badge: false
};

StatusProgressBar.propTypes = {
  badge: PropTypes.bool,
  progress: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired
};

const TaskButton = ({ disabled, icon, pathToConnector, task, title, variant, onClickFunction }) => {
  // const connector = get(task, pathToConnector, {});
  // const link = `ftp://${connectorOps.getUser(connector)}:${connectorOps.getPassword(
  //   connector
  // )}@${connectorOps.getIp(connector)}:${connectorOps.getPort(connector)}${connectorOps.getFilePath(
  //   connector
  // )}`;
  return (
    <TableButtonCell className={CLASS_BUTTON_CELL}>
      {isEmpty(pathToConnector) && (
        <Button
          disabled={disabled}
          title={title}
          variant={variant}
          onClick={event => {
            event.stopPropagation();
            onClickFunction(taskOps.getId(task));
          }}
        >
          <FontAwesomeIcon icon={icon} size="lg" />
        </Button>
      )}
      {/* Esto se deja así de cara a que salga un sitio donde se pueda abrir */}
      {/* {!isEmpty(pathToConnector) && (
        <a
          href={link}
          target="_blank"
          rel="noreferrer"
          onClick={event => {
            event.stopPropagation();
          }}
        >
          <Button disabled={disabled} title={title} variant={variant}>
            <FontAwesomeIcon icon={icon} size="lg" />
          </Button>
        </a>
      )} */}
    </TableButtonCell>
  );
};

TaskButton.defaultProps = {
  disabled: false,
  pathToConnector: '',
  onClickFunction: () => ''
};
TaskButton.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  pathToConnector: PropTypes.string,
  task: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  onClickFunction: PropTypes.func
};

const TaskRowContents = ({
  task,
  isAtlas,
  isEditing,
  isFocusTrainAtlas,
  isMonitor,
  isPreview,
  isPublic,
  pathToConnector,
  subtaskList,
  deleteTask,
  openConfirmation,
  pauseTask,
  renameTask,
  resumeTask,
  selectTask
}) => {
  const taskButtons = [
    {
      disabled: isPublic,
      icon: 'times',
      title: isMonitor ? 'Cancel' : 'Delete',
      variant: 'danger',
      onClickFunction: isMonitor ? openConfirmation : deleteTask
    }
  ];
  if (isMonitor && !isAtlas) {
    taskButtons.splice(0, 0, {
      icon: taskOps.isPaused(task) ? 'play' : 'pause',
      title: taskOps.isPaused(task) ? 'Resume' : 'Pause',
      variant: taskOps.isPaused(task) ? 'success' : 'info',
      onClickFunction: taskOps.isPaused(task) ? resumeTask : pauseTask
    });
  }
  if (isMonitor && isFocusTrainAtlas) {
    taskButtons.splice(0, 0, {
      icon: 'download',
      pathToConnector,
      title: 'Get Results',
      variant: 'secondary'
    });
  }

  if (isAtlas)
    return (
      <Table borderless className="my-0" onClick={() => selectTask(task)}>
        <tbody>
          <Styles.Tr className="py-0">
            <td className={CLASS_NAME_DATE_AUTO_NP_SHOW_XS}>{taskOps.getName(task)}</td>
            <td className={CLASS_NAME_DATE_50_NP_SHOW_XS}>
              <StatusProgressBar
                badge
                progress={taskOps.getProgress(task)}
                status={taskOps.getStatus(task)}
              />
            </td>
            {!isPreview &&
              map(taskButtons, buttonProps => (
                <TaskButton key={uuid()} task={task} {...buttonProps} />
              ))}
          </Styles.Tr>
        </tbody>
      </Table>
    );

  return (
    <>
      <Table borderless className="mt-0">
        <tbody>
          <Styles.Tr className="py-0">
            <td className={CLASS_NAME_DATE_17_NP}>
              {isEditing ? (
                <InputGroup className="m-0" onClick={event => event.stopPropagation()}>
                  <Form.Control name="name" defaultValue={taskOps.getLabel(task)} />
                  <InputGroup.Append>
                    <Button
                      onClick={event => {
                        const newLabel = event.target.parentElement.parentElement.children[0].value.trim();
                        const taskId = taskOps.getId(task);
                        renameTask({ taskId, newLabel });
                      }}
                      variant="success"
                    >
                      Save
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              ) : (
                taskOps.getLabel(task)
              )}
            </td>
            <td className={CLASS_NAME_DATE_50_NP}>Comments</td>
            <td className={CLASS_NAME_DATE_AUTO_NP}>
              {monthDayYearAtTime(taskOps.getStartDate(task))}
            </td>
            <td className={CLASS_NAME_DATE_AUTO_NP}>
              {`Exec. Time: ${difference(taskOps.getStartDate(task), taskOps.getFinishDate(task))}`}
            </td>
            {map(taskButtons, buttonProps => (
              <TaskButton key={uuid()} task={task} {...buttonProps} />
            ))}
          </Styles.Tr>
        </tbody>
      </Table>
      <Table borderless className="mb-0">
        <tbody>
          <Styles.Tr>
            <td className={CLASS_NAME_DATE_17_NP}>
              {!isEmpty(subtaskList) && (
                <>
                  <FontAwesomeIcon icon="bars" className="mr-2 mt-1" />
                  {`Processes (${subtaskList.length})`}
                </>
              )}
            </td>
            <td className={CLASS_NAME_DATE_50_NP}>{taskOps.getComments(task)}</td>
            <td className={CLASS_NAME_DATE_33_NP}>
              <StatusProgressBar
                badge
                progress={taskOps.getProgress(task)}
                status={taskOps.getStatus(task)}
              />
            </td>
          </Styles.Tr>
        </tbody>
      </Table>
    </>
  );
};

TaskRowContents.propTypes = {
  task: PropTypes.object.isRequired,
  isAtlas: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isFocusTrainAtlas: PropTypes.bool.isRequired,
  isMonitor: PropTypes.bool.isRequired,
  isPreview: PropTypes.bool.isRequired,
  isPublic: PropTypes.bool.isRequired,
  pathToConnector: PropTypes.string.isRequired,
  subtaskList: PropTypes.array.isRequired,
  deleteTask: PropTypes.func.isRequired,
  openConfirmation: PropTypes.func.isRequired,
  pauseTask: PropTypes.func.isRequired,
  renameTask: PropTypes.func.isRequired,
  resumeTask: PropTypes.func.isRequired,
  selectTask: PropTypes.func.isRequired
};

const SubTaskRowContents = ({ subtask }) => (
  <tbody>
    <tr>
      <td role="gridcell" className={CLASS_NAME_HEAD_AUTO}>
        {nodeOps.getLabel(subtask)}
      </td>
      <td role="gridcell" className={CLASS_NAME_DATE_AUTO}>
        <StatusBadgeIcon status={nodeOps.getStatus(subtask)} />
      </td>
      <td role="gridcell" className={CLASS_NAME_HEAD_25}>
        {nodeOps.getComments(subtask)}
      </td>
      <td role="gridcell" className={CLASS_NAME_HEAD_25}>
        <StatusProgressBar
          progress={nodeOps.getProgress(subtask)}
          status={nodeOps.getStatus(subtask)}
        />
      </td>
      <td role="gridcell" className={CLASS_NAME_DATE_AUTO}>
        {timeago(nodeOps.getStartDate(subtask))}
      </td>
      <td role="gridcell" className={CLASS_NAME_DATE_AUTO}>
        {difference(nodeOps.getStartDate(subtask), nodeOps.getFinishDate(subtask))}
      </td>
    </tr>
  </tbody>
);

SubTaskRowContents.propTypes = {
  subtask: PropTypes.object.isRequired
};

class TaskList extends Component {
  state = {
    isEditing: false,
    isTrashOpen: false,
    isConfirmationOpen: false,
    selectedTask: ''
  };

  closeConfirmation = () => this.setState({ isConfirmationOpen: false, selectedTask: '' });

  closeTrash = () => this.setState({ isTrashOpen: false });

  handleCancel = async () => {
    const { selectedTask } = this.state;
    this.closeConfirmation();
    try {
      let debugIP = '';
      if (isBeta) {
        debugIP = get(this, 'debugComponent.current.serverIP', '');
      }
      await methodPromise('tasks.cancel', { taskId: selectedTask, debugIP });
      Bert.alert('Task canceled!', 'danger');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleEdit = newIsEditing => this.setState({ isEditing: newIsEditing });

  handleHardRemove = async taskId => {
    try {
      await methodPromise('tasks.hardDelete', taskId);
      Bert.alert('Task deleted!', 'danger');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handlePause = async taskId => {
    try {
      let debugIP = '';
      if (isBeta) {
        debugIP = get(this, 'debugComponent.current.serverIP', '');
      }
      await methodPromise('tasks.pause', { taskId, debugIP });
      Bert.alert('Task paused!', 'warning');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleRestore = async taskId => {
    try {
      await methodPromise('tasks.restore', taskId);
      Bert.alert('Task restored!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleResume = async taskId => {
    try {
      let debugIP = '';
      if (isBeta) {
        debugIP = get(this, 'debugComponent.current.serverIP', '');
      }
      await methodPromise('tasks.resume', { taskId, debugIP });
      Bert.alert('Task resumed!', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleSoftRemove = async taskId => {
    try {
      await methodPromise('tasks.softDelete', taskId);
      Bert.alert('Task moved to Trash!!', 'warning');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleTaskLabelChange = async ({ taskId, newLabel }) => {
    try {
      await methodPromise('tasks.updateTaskLabel', taskId, newLabel);
      Bert.alert(`Task "${newLabel}" Renamed!`, 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  openConfirmation = taskId => this.setState({ isConfirmationOpen: true, selectedTask: taskId });

  openTrash = () => this.setState({ isTrashOpen: true });

  render() {
    const {
      currentPage,
      deletedCount,
      deletedTasks,
      filteredCount,
      isAtlas,
      isFocusTrainAtlas,
      isMonitor,
      isPreview,
      isPublic,
      itemsPerPage,
      loading,
      networkError,
      pathToConnector,
      taskList,
      totalCount,
      changePage,
      getResults,
      handleSearch,
      selectTask
    } = this.props;
    const { isEditing, isTrashOpen, isConfirmationOpen } = this.state;

    if (loading) return <Loading />;
    if (networkError) return <Alert variant="danger">Network Error</Alert>;

    let cardHeaderClassName = '';
    if (taskList.length === 1) cardHeaderClassName += 'mb-0';
    if (isAtlas) cardHeaderClassName += ' py-0';

    return (
      <>
        <Trash
          isTrashOpen={isTrashOpen}
          closeTrash={this.closeTrash}
          restoreItem={this.handleRestore}
          deleteItem={this.handleHardRemove}
          deletedItems={deletedTasks}
          deletedCount={deletedCount}
        />
        <ConfirmationModal
          message="This will cancel this task and delete it from the server. Continue?"
          showModal={isConfirmationOpen}
          title="Cancel running task"
          onCloseFunction={this.closeConfirmation}
          onConfirmFunction={this.handleCancel}
        />
        <PageHeader>
          <div className="d-flex flex-row w-100 justify-content-between">
            {!isAtlas && (
              <h4>
                Tasks ({totalCount})
                {!isString(filteredCount) && filteredCount > 0 && (
                  <span
                    className="badge badge-pill badge-info d-none d-sm-inline"
                    style={{ fontSize: '11px' }}
                  >
                    <FontAwesomeIcon icon="filter" className="mr-1" />
                    {`Filtered (${filteredCount})`}
                  </span>
                )}
              </h4>
            )}
            <div className={`d-flex ${isAtlas ? 'px-3' : 'flex-row align-items-center'}`}>
              {isMonitor && (
                <Button
                  variant="success"
                  className="mr-1"
                  disabled={isPreview || isPublic}
                  onClick={getResults}
                >
                  Get Results
                </Button>
              )}
              <SearchInput placeholder="Search task..." onKeyUp={handleSearch} />
              {!isMonitor && (
                <>
                  <Button
                    variant={!isEditing ? 'outline-info' : 'outline-warning'}
                    className="mr-1"
                    onClick={() => this.handleEdit(!isEditing)}
                  >
                    {!isEditing ? 'Edit' : 'Editing'}
                  </Button>
                  <Button variant="light" onClick={this.openTrash} title="Open Trash">
                    <FontAwesomeIcon icon="trash-alt" />
                  </Button>
                </>
              )}
            </div>
          </div>
        </PageHeader>
        {isEmpty(taskList) && <Alert variant="danger">No tasks found</Alert>}
        <Accordion defaultActiveKey="0">
          {map(taskList, runningTask => {
            const task = new Task(runningTask);
            const subtaskList = task.getSubTasks();
            return (
              <Card key={uuid()}>
                <Accordion.Toggle
                  as={Card.Header}
                  className={cardHeaderClassName}
                  eventKey={taskOps.getId(runningTask)}
                >
                  <TaskRowContents
                    task={runningTask}
                    isAtlas={isAtlas}
                    isEditing={isEditing}
                    isFocusTrainAtlas={isFocusTrainAtlas}
                    isMonitor={isMonitor}
                    isPreview={isPreview}
                    isPublic={isPublic}
                    pathToConnector={pathToConnector}
                    subtaskList={subtaskList}
                    deleteTask={this.handleSoftRemove}
                    openConfirmation={this.openConfirmation}
                    pauseTask={this.handlePause}
                    renameTask={this.handleTaskLabelChange}
                    resumeTask={this.handleResume}
                    selectTask={selectTask}
                  />
                </Accordion.Toggle>
                {!isEmpty(subtaskList) && !isAtlas && (
                  <Accordion.Collapse eventKey={taskOps.getId(runningTask)}>
                    <Card.Body>
                      <Table responsive hover borderless size="sm">
                        <thead className="thead-dark">
                          <tr>
                            <th className={CLASS_NAME_HEAD_AUTO}> Process </th>
                            <th className={CLASS_NAME_DATE_AUTO}> Status </th>
                            <th className={CLASS_NAME_HEAD_25}> Comments </th>
                            <th className={CLASS_NAME_HEAD_25}> Progress </th>
                            <th className={CLASS_NAME_DATE_AUTO}> Started </th>
                            <th className={CLASS_NAME_DATE_AUTO}> Exec. time </th>
                          </tr>
                        </thead>
                        {map(subtaskList, subtask => (
                          <SubTaskRowContents key={uuid()} subtask={subtask} />
                        ))}
                      </Table>
                    </Card.Body>
                  </Accordion.Collapse>
                )}
              </Card>
            );
          })}
        </Accordion>
        <TablePagination
          totalCount={totalCount}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          changePage={changePage}
          isPaginationOn
        />
      </>
    );
  }
}

TaskList.defaultProps = {
  deletedCount: 0,
  deletedTasks: [],
  filteredCount: '',
  isAtlas: false,
  isFocusTrainAtlas: false,
  isMonitor: false,
  isPreview: false,
  isPublic: false,
  pathToConnector: '',
  getResults: () => false,
  selectTask: () => false
};

TaskList.propTypes = {
  currentPage: PropTypes.number.isRequired,
  deletedCount: PropTypes.number,
  deletedTasks: PropTypes.array,
  filteredCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isAtlas: PropTypes.bool,
  isFocusTrainAtlas: PropTypes.bool,
  isMonitor: PropTypes.bool,
  isPreview: PropTypes.bool,
  isPublic: PropTypes.bool,
  itemsPerPage: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  networkError: PropTypes.bool.isRequired,
  pathToConnector: PropTypes.string,
  taskList: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
  changePage: PropTypes.func.isRequired,
  getResults: PropTypes.func,
  handleSearch: PropTypes.func.isRequired,
  selectTask: PropTypes.func
};

export default TaskList;
